import { createBrowserRouter } from "react-router-dom";
import ErrorPage from "../../Components/ErrorPage";
import UnauthorizedPage from "../../Components/UnauthorizedPage";
import HomeLayout from "../../Layout/HomeLayout";
import InvitationLinkExpired from "../../Layout/InvitationLinkExpired";
import NewWorkspaceLayout from "../../Layout/NewWorkspaceLayout";
import PaymentGateWay from "../../Services/Stripe-Payment/PaymentGateWay";
import CreateDebate from "../CreateDebate/CreateDebate";
import CreateNewDebate from "../CreateDebate/NewCreateDebate/CreateDebate";
import Debated from "../Home/Debated";
import Home from "../Home/Home";
import Private from "../Home/Private";
import PublicDebated from "../Home/PublicDebated";
import PublicHome from "../Home/PublicHome";
import PublicVoted from "../Home/PublicVoted";
import Voted from "../Home/Voted";
import Library from "../Library/Library";
import Group from "../Messaging/group/Group";
import Message from "../Messaging/individual/Message";
import MessageModule from "../Messaging/individual/MessageModule";
import NewMessage from "../Messaging/NewMessage";
import FindMotion from "../Motion/FindMotion";
import SuggestMotion from "../Motion/SuggestMotion";
import News from "../News/News";
import MainNotification from "../Notification/MainNotification";
import AddArgument from "../Posts/AddArgument";
import AddInvites from "../Posts/AddInvites";
import DebateDetail from "../Posts/DebateDetail";
import ActiveDebateResults from "../Profile/ActiveDebateResults";
import ActiveDraftsTabs from "../Profile/ActiveDraftsTabs";
import DebateResultTabs from "../Profile/DebateResultTabs";
import FollowerTabs from "../Profile/FollowerTabs";
import MySaveTab from "../Profile/MySaveTab";
import OpenDebate from "../Profile/OpenDebate";
import UserProfile from "../Profile/UserProfile";
import AddWorkspace from "../Public/AddWorkspace";
import Join from "../Public/Join";
import OTPVerification from "../Public/OTPVerification";
import SignIn from "../Public/SignIn";
import SignUpMain from "../Public/SignUpMain";
import WorkspaceHome from "../Public/WorkspaceHome";
import Reference from "../Reference/Reference";
import RoleManagment from "../RoleManagement/RoleManagment";
import SearchTabs from "../Search/SearchTabs";
import ContactUs from "../SubscriptionPlan/ContactUs";
import PaymentFailed from "../SubscriptionPlan/PaymentFailed";
import PaymentProcessing from "../SubscriptionPlan/PaymentProcessing";
import PaymentSuccess from "../SubscriptionPlan/PaymentSuccess";
import UpdateCheckOutPage from "../SubscriptionPlan/UpdateCheckOutPage";
import UpgradeAIPlan from "../SubscriptionPlan/UpgradeAIPlan";
import UpgradePlan from "../SubscriptionPlan/UpgradePlan";
import UpdateDebate from "../UpdateDebate/UpdateDebate";
import ProtectedRoute from "./ProtectedRoutes";
import ManageSubscriptionPage from "../SubscriptionPlan/ManageSubscriptionPage";
import RedirectToApp from "../Public/RedirectToApp";
import ForumHome from "../Home/ForumHome";

export const router = createBrowserRouter([
  {
    // parent route component
    element: (
      <ProtectedRoute>
        <HomeLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorPage />,
    // child route components
    children: [
      {
        path: "/manage-subscription",
        element: <ManageSubscriptionPage />,
      },
      {
        path: "/feed",
        element: <Home />,
      },
      {
        path: "/feed/:forumId",
        element: <ForumHome />,
      },
      {
        path: "/feed-public",
        element: <PublicHome />,
      },
      {
        path: "/debated-public",
        element: <PublicDebated />,
      },
      {
        path: "/debated-public/:profileId",
        element: <PublicDebated />,
      },
      {
        path: "/voted-public",
        element: <PublicVoted />,
      },
      {
        path: "/voted-public/:profileId",
        element: <PublicVoted />,
      },
      {
        path: "/debate/:debateId",
        element: <DebateDetail />,
      },
      // other pages....
      {
        path: "/debated",
        element: <Debated />,
      },
      {
        path: "/reference",
        element: <Reference />,
      },
      {
        path: "/debated/:profileId",
        element: <Debated />,
      },
      {
        path: "/debate/:debateId/add-argument",
        element: <AddArgument />,
      },
      {
        path: "/debate/:debateId/add-invite",
        element: <AddInvites />,
      },
      {
        path: "/voted",
        element: <Voted />,
      },
      {
        path: "/voted/:profileId",
        element: <Voted />,
      },
      {
        path: "/private",
        element: <Private />,
      },
      {
        path: "/private/:profileId",
        element: <Private />,
      },
      {
        path: "/news",
        element: <News />,
      },
      {
        path: "/search",
        element: <SearchTabs />,
      },
      {
        path: "/profile/:profileId",
        element: <UserProfile />,
      },
      {
        path: "notification",
        element: <MainNotification />,
      },
      {
        path: "suggestMotion",
        element: (
          <ProtectedRoute checkAccess={true}>
            {" "}
            <SuggestMotion />
          </ProtectedRoute>
        ),
      },
      {
        path: "findMotion",
        element: (
          <ProtectedRoute checkAccess={true}>
            <FindMotion />
          </ProtectedRoute>
        ),
      },
      {
        path: "profile/active-drafts",
        element: <ActiveDraftsTabs />,
      },
      {
        path: "debate-results/:debateId",
        element: <ActiveDebateResults />,
      },
      {
        path: "profile/follower-management",
        element: <FollowerTabs />,
      },
      {
        path: "profile/debate-result",
        element: <DebateResultTabs />,
      },
      {
        path: "profile/open-debate",
        element: <OpenDebate />,
      },
      {
        path: "debate-results/:debateId",
        element: <ActiveDebateResults />,
      },
      {
        path: "profile/mysave",
        element: <MySaveTab />,
      },
      {
        path: "library",
        element: <Library />,
      },
      {
        path: "roleManagement",
        element: (
          <ProtectedRoute>
            {" "}
            <RoleManagment />
          </ProtectedRoute>
        ),
      },
      {
        path: "/update-debate",
        element: (
          <ProtectedRoute>
            <CreateDebate />
          </ProtectedRoute>
        ),
        children: [
          {
            path: "",
            element: <UpdateDebate />,
          },
        ],
      },
      {
        path: "/createDebate",
        element: (
          <ProtectedRoute checkAccess={true}>
            <CreateDebate />
          </ProtectedRoute>
        ),
        children: [
          {
            path: "", // Changed to relative path
            element: <CreateNewDebate />,
          },
        ],
      },

      {
        path: "/messageOption",
        element: (
          <ProtectedRoute checkAccess={true}>
            <MessageModule />
          </ProtectedRoute>
        ),
        children: [
          {
            path: ":profileId",
            element: <Message />,
          },
          {
            path: "",
            element: <NewMessage />,
          },
        ],
      },
      {
        path: "/group-message",
        element: (
          <ProtectedRoute>
            <MessageModule />
          </ProtectedRoute>
        ),
        children: [
          {
            path: ":groupId",
            element: <Group />,
          },
          {
            path: "",
            element: <NewMessage />,
          },
        ],
      },
    ],
  },
  {
    path: "/unauthorized",
    element: (
      <ProtectedRoute>
        <UnauthorizedPage />
      </ProtectedRoute>
    ),
  },
  {
    // parent route component
    // child route components
    errorElement: <ErrorPage />,
    children: [
      {
        path: "upgrade-plan",
        element: (
          <ProtectedRoute>
            <UpgradePlan />
          </ProtectedRoute>
        ),
      },
      {
        path: "upgrade-AI-plan",
        element: <UpgradeAIPlan />,
      },
      {
        path: "upgrade-plan/:planId",
        element: (
          <ProtectedRoute>
            <PaymentGateWay />
          </ProtectedRoute>
        ),
      },
      {
        path: "upgrade-plan/update/:planId",
        element: (
          <ProtectedRoute>
            <UpdateCheckOutPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "payment-success",
        element: (
          <ProtectedRoute>
            <PaymentSuccess />
          </ProtectedRoute>
        ),
      },
      {
        path: "payment-pending",
        element: (
          <ProtectedRoute>
            <PaymentProcessing />
          </ProtectedRoute>
        ),
      },
      {
        path: "contact-us",
        element: (
          <ProtectedRoute>
            <ContactUs />
          </ProtectedRoute>
        ),
      },
      {
        path: "payment-failed",
        element: (
          <ProtectedRoute>
            <PaymentFailed />
          </ProtectedRoute>
        ),
      },
      {
        path: "/join",
        element: <Join />,
      },
      {
        path: "/debatebase/*",
        element: <RedirectToApp />,
      },
      {
        path: "/",
        element: <SignIn />,
      },
      {
        path: "/signup",
        element: <SignUpMain />,
      },
      {
        path: "/otp-login",
        element: <OTPVerification />,
      },
      {
        path: "/createworkspace",
        element: (
          <ProtectedRoute>
            <WorkspaceHome />
          </ProtectedRoute>
        ),
      },
      {
        path: "/invitation-expired",
        element: <InvitationLinkExpired />,
      },
    ],
  },
  {
    element: (
      <ProtectedRoute>
        <NewWorkspaceLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/createprofile",
        element: <AddWorkspace />,
      },
    ],
  },
]);
